import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      title: "DIGITAL BUSINESS LOAN",
      img: "img1.jpg",
      text: "Get the financial support your business needs with our Business Loan services. Our flexible terms and competitive rates are designed to help your business thrive. Explore opportunities for growth and expansion today!"
    },
    {
      title: "HOME LOAN",
      img: "img2.jpg",
      text: "Turn your dream home into a reality with our Home Loan options. Whether you're a first-time buyer or looking to upgrade, our affordable home financing solutions are tailored to meet your needs. Find the perfect loan for your dream home."
    },
    {
      title: "PERSONAL LOAN",
      img: "img3.jpg",
      text: "Unleash the possibilities with our Personal Loan services. Whether it's for a special occasion, travel, or unexpected expenses, our personal loans offer quick and hassle-free solutions. Experience financial flexibility with us!"
    },
    {
      title: "LOAN AGAINST BOND",
      img: "who.jpg",
      text: "Insurance for a loan is typically required to protect both the borrower and the lender in case of unforeseen events that could affect the borrower's ability to repay the loan. Our loan against bond options provide security and competitive rates for your financial needs."
    }
  ];

  return (
    <div className="container py-5" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Heading */}
      <div className="row mb-5">
        <div className="col-12 text-center">
          <h2 className="display-5 fw-bold" style={{ color: '#8B0000' }}>Our Premium Services</h2>
          <p className="lead text-muted">Discover our exclusive financial solutions tailored for your needs</p>
          <div style={{ 
            height: '4px', 
            width: '80px', 
            backgroundColor: '#8B0000', 
            margin: '0 auto',
            borderRadius: '2px'
          }}></div>
        </div>
      </div>

      {/* Services Grid */}
      <div className="row">
        {services.map((service, index) => (
          <div className="col-12 col-sm-6 col-lg-3 mb-4" key={index}>
            <div className="card h-100 shadow-lg border-0" style={{ 
              borderRadius: '15px',
              overflow: 'hidden',
              transition: 'transform 0.3s, box-shadow 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px)';
              e.currentTarget.style.boxShadow = '0 12px 20px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
            }}>
              <div style={{ 
                height: '200px', 
                overflow: 'hidden',
                position: 'relative'
              }}>
                <img 
                  src={service.img} 
                  className="card-img-top" 
                  alt={service.title}
                  style={{ 
                    height: '100%', 
                    width: '100%', 
                    objectFit: 'cover',
                    transition: 'transform 0.5s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                  }}
                />
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  right: '0',
                  bottom: '0',
                  background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 100%)',
                  opacity: '0.7'
                }}></div>
                <h5 className="card-title position-absolute text-white fw-bold" style={{ 
                  bottom: '10px', 
                  left: '15px', 
                  zIndex: '1',
                  fontSize: '1.2rem',
                  textShadow: '1px 1px 3px rgba(0,0,0,0.7)'
                }}>{service.title}</h5>
              </div>
              <div className="card-body d-flex flex-column" style={{ padding: '1.5rem' }}>
                <p 
                  className="card-text flex-grow-1"
                  style={{
                    fontSize: '0.95rem',
                    lineHeight: '1.6',
                    color: '#555'
                  }}
                >
                  {service.text.length > 150 ? service.text.substring(0, 150) + '...' : service.text}
                </p>
                <button
                  type="button"
                  className="btn mt-3 fw-semibold py-2"
                  style={{
                    backgroundColor: '#8B0000',
                    borderColor: '#8B0000',
                    color: 'white',
                    borderRadius: '8px',
                    transition: 'all 0.3s'
                  }}
                  data-bs-toggle="modal" 
                  data-bs-target="#loanApplicationModal"
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#6d0000';
                    e.target.style.transform = 'scale(1.03)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#8B0000';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

     
    </div>
  );
};

export default Services;